import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TaxiAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"taxi_alert"}/>
}
